import { regions } from "@wise/regions";
import { FormatError } from "../errors/format.js";
import { WiseId } from "./base.js";
export class JobId extends WiseId {
    _tenant;
    _region;
    _version;
    _id;
    static fromColon(colon) {
        const [tenant, version, region, id] = colon.split(":");
        return new JobId(id, tenant, region, version);
    }
    static fromLocal(id, region) {
        return new JobId(id, undefined, region);
    }
    static fromUrl(url) {
        try {
            const u = new URL(url);
            const [tenant] = u.hostname.split(".");
            const [, , version, region, id] = u.pathname.split("/");
            return new JobId(id, tenant, region, version);
        }
        catch (e) {
            throw new FormatError(`Invalid url: ${url}`);
        }
    }
    static fromPath(path) {
        const [tenant, version, region, id] = path.split("/");
        return new JobId(id, tenant, region, version);
    }
    static isJobId(obj) {
        return obj instanceof JobId;
    }
    static isJobIdUrl(url) {
        try {
            const u = new URL(url);
            const [tenant] = u.hostname.split(".");
            const [, type, version, region, id] = u.pathname.split("/");
            return (type === "jobs" &&
                typeof tenant === "string" &&
                typeof version === "string" &&
                typeof region === "string" &&
                typeof id === "string" &&
                id.length === 36 &&
                Object.keys(regions).includes(region) &&
                u.pathname === `/jobs/${version}/${region}/${id}`);
        }
        catch (e) {
            return false;
        }
    }
    constructor(id, tenant = process.env.TENANT ?? "researchwiseai", region = "eu", version = "v1") {
        super();
        this._id = id;
        this._tenant = tenant;
        this._region = region;
        this._version = version;
        this.validate();
    }
    get tenant() {
        return this._tenant;
    }
    get region() {
        return this._region;
    }
    get version() {
        return this._version;
    }
    get id() {
        return this._id;
    }
    toColon() {
        return `${this.tenant}:${this.version}:${this.region}:${this.id}`;
    }
    toPath() {
        return `${this.tenant}/${this.version}/${this.region}/${this.id}`;
    }
    toUrl() {
        return `https://${this.tenant}.com/jobs/${this.version}/${this.region}/${this.id}`;
    }
    validate() {
        if (!this.id) {
            throw new FormatError("id is required");
        }
        if (typeof this.tenant !== "string") {
            throw new FormatError("tenant must be a string");
        }
        if (typeof this.region !== "string") {
            throw new FormatError("region must be a string");
        }
        if (typeof this.version !== "string") {
            throw new FormatError("version must be a string");
        }
        if (typeof this.id !== "string") {
            throw new FormatError("id must be a string");
        }
        if (!Object.keys(regions).includes(this._region)) {
            throw new FormatError(`region must be one of ${Object.keys(regions).join(", ")}`);
        }
    }
}
